var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9299 31.6492C14.8497 31.6515 13.8519 31.0725 13.318 30.1336C12.7918 29.2004 12.8233 28.053 13.4 27.1502L18.7788 18.7038C19.3392 17.7796 20.3536 17.2285 21.4339 17.2611C22.5135 17.287 23.4954 17.8923 24.0036 18.8451C24.505 19.7932 24.4423 20.9339 23.8418 21.8239L18.4665 30.2703C17.9125 31.1336 16.9556 31.6538 15.9299 31.6492Z",
    fill: "#F62B54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1557 31.6488C24.0708 31.6488 23.0726 31.0688 22.5484 30.1366C22.0233 29.206 22.0549 28.0615 22.6304 27.1612L27.9989 18.7342C28.5513 17.7968 29.5686 17.2327 30.6563 17.2608C31.7503 17.2847 32.7417 17.8966 33.2431 18.8539C33.7411 19.8111 33.6682 20.9586 33.0494 21.8463L27.6821 30.2734C27.1298 31.1329 26.1774 31.6515 25.1557 31.6488Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1752 31.7208C35.7045 31.7208 36.9443 30.5071 36.9443 29.0098C36.9443 27.5126 35.7045 26.2988 34.1752 26.2988C32.6458 26.2988 31.4061 27.5126 31.4061 29.0098C31.4061 30.5071 32.6458 31.7208 34.1752 31.7208Z",
    fill: "#00CA72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonday);
export default __webpack_public_path__ + "static/media/Monday.b618be43ab84f02944bd74cad5f015e7.svg";
export { ForwardRef as ReactComponent };